import { useEffect } from "react";
import * as CookieConsentApi from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

export const CookieConsent = (): null => {
  useEffect(() => {
    CookieConsentApi.run({
      categories: {
        analytics: {
          enabled: true,
          readOnly: false,
          services: {
            ga: {
              cookies: [
                {
                  name: /^(_ga|_gid)/,
                },
              ],
              label: "Google Analytics",
            },
          },
        },
        necessary: {
          readOnly: true,
        },
      },
      disablePageInteraction: true,
      guiOptions: {
        consentModal: {
          layout: "bar",
          position: "bottom",
        },
      },
      language: {
        autoDetect: "browser",
        default: "en",
        translations: {
          en: {
            consentModal: {
              acceptAllBtn: "Accept all cookies",
              acceptNecessaryBtn: "Accept necessary cookies",
              description:
                'We use cookies to improve your user experience, to collect statistics for analyzing how the website is used and for customized advertising in social media and other websites you visit. By clicking "Accept all cookies", you are giving your consent to the use of cookies by Equinor Sell To and third parties on this website. You can also choose your preferences regarding cookies by clicking on "Manage Individual preferences".',
              showPreferencesBtn: "Manage Individual preferences",
              title: "We use cookies",
            },
            preferencesModal: {
              acceptAllBtn: "Accept all cookies",
              acceptNecessaryBtn: "Accept necessary cookies",
              closeIconLabel: "Close modal",
              savePreferencesBtn: "Accept current selection",
              sections: [
                {
                  description:
                    "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                  title: "Cookie usage",
                },
                {
                  description:
                    "These cookies are essential for the proper functioning of website. Without these cookies, the website would not work properly.",
                  linkedCategory: "necessary",
                  title: "Strictly necessary cookies",
                },
                {
                  description:
                    "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you.",
                  linkedCategory: "analytics",
                  title: "Analytics cookies",
                },
              ],
              title: "Manage cookie preferences",
            },
          },
          "pt-BR": {
            consentModal: {
              acceptAllBtn: "Aceitar todos os cookies",
              acceptNecessaryBtn: "Aceitar cookies necessários",
              description:
                'Usamos cookies para melhorar sua experiência de usuário, coletar estatísticas para analisar como o site é usado e para publicidade personalizada nas mídias sociais e outros sites que você visita. Ao clicar em "Aceitar todos os cookies", você está dando seu consentimento para o uso de cookies pela Equinor Sell To e terceiros neste site. Você também pode escolher suas preferências em relação aos cookies, clicando em "Gerenciar preferências individuais".',
              showPreferencesBtn: "Gerenciar preferências individuais",
              title: "Este site usa cookies",
            },
            preferencesModal: {
              acceptAllBtn: "Aceitar todos os cookies",
              acceptNecessaryBtn: "Aceitar cookies necessários",
              closeIconLabel: "Fechar modal",
              savePreferencesBtn: "Aceitar a seleção atual",
              sections: [
                {
                  description:
                    "Usamos cookies para garantir as funcionalidades básicas do site e para aprimorar sua experiência online. Você pode escolher cada categoria para aceitar/rejeitar sempre que quiser.",
                  title: "Uso de cookies",
                },
                {
                  description:
                    "Esses cookies são essenciais para o bom funcionamento do site. Sem esses cookies, o site não funcionará corretamente.",
                  linkedCategory: "necessary",
                  title: "Cookies estritamente necessários",
                },
                {
                  description:
                    "Esses cookies coletam informações sobre como você usa o site, quais páginas você visitou e em quais links você clicou. Todos os dados são anonimizados e não podem ser usados para identificá-lo.",
                  linkedCategory: "analytics",
                  title: "Cookies analíticos",
                },
              ],
              title: "Gerenciar preferências de cookies",
            },
          },
        },
      },
    });
  }, []);

  return null;
};
